import { ItemList } from 'orm'

class KpiList extends ItemList {
    getEntityKey() {
        return "admin/kpi"
    }
}

export const adminKpiList = new KpiList("admin_kpi__default")
